module.exports = __webpack_public_path__ + "media/images/wind-2x-f2fc2670065de41d46d3b9fabb2d4da4.png";